import React from 'react'
import {withTheme} from 'styled-components'
import {translate} from 'react-i18next'
import Separator from 'components/separator'
import CircularSocialLogin from 'components/circular-social-login'
import {compose} from 'utils/reactUtils'
import {getConfigValue} from 'theme'
import SocialLogin from './SocialLogin'

const SocialLoginContainer = ({showSeparator = false, ...props}) => {
  const useCircularSocialLogin = getConfigValue('useCircularSocialLogin')

  return (
    <>
      {showSeparator && <Separator withText={!useCircularSocialLogin} />}
      {useCircularSocialLogin ? <CircularSocialLogin {...props} /> : <SocialLogin {...props} />}
    </>
  )
}
export default compose(translate(), withTheme)(SocialLoginContainer)
